<template>
	<div class="ca-addedToCart">
		<svg viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M1 4.2L3.4 6.6L9 1" stroke="white" />
		</svg>

		<!-- <span>{{ translations["Added"] }}</span> -->
	</div>
</template>

<script>
export default {
	name: 'AnimationAddedToCart',
};
</script>

<style lang="scss">
@import '@backend/scss/abstracts/variables.scss';
@import '@backend/scss/abstracts/mixins.scss';

.ca-addedToCart {
	svg {
		width: 10px;
		height: 8px;
		stroke-width: 1.5px;

		position: relative;
		top: -2px;
		// left: -10px;
		transform: scale(2);

		animation: checkstroke 800ms normal forwards ease-in-out;
	}

	@keyframes checkstroke {
		0% {
			opacity: 0;
			stroke-dasharray: 16px;
			stroke-dashoffset: 16px;
		}
		10% {
			opacity: 0;
		}
		70% {
			opacity: 1;
		}
		100% {
			stroke-dashoffset: 0;
		}
	}
}
</style>
